import classNames from 'classnames';
import * as React from 'react';
import YouTube from 'react-youtube';
import { Picture } from '../Picture/Picture';
import { Vimeo } from '../Vimeo/Vimeo';
import styles from './CarouselItem.module.css';
import { CarouselItemType } from './CarouselItemType.csharp';
import type { ICarouselItemViewModel } from './ICarouselItemViewModel.csharp';
import type { ImageCarouselItemViewModel } from './ImageCarouselItemViewModel.csharp';
import type { VimeoVideoCarouselItemViewModel } from './VimeoVideoCarouselItemViewModel.csharp';
import type { YouTubeVideoCarouselItemViewModel } from './YouTubeVideoCarouselItemViewModel.csharp';

const isImage = (input: ICarouselItemViewModel): input is ImageCarouselItemViewModel =>
    input.type === CarouselItemType.Image;

const isYoutubeVideo = (input: ICarouselItemViewModel): input is YouTubeVideoCarouselItemViewModel =>
    input.type === CarouselItemType.YouTubeVideo;

const isVimeoVideo = (input: ICarouselItemViewModel): input is VimeoVideoCarouselItemViewModel =>
    input.type === CarouselItemType.VimeoVideo;

export class CarouselItem extends React.PureComponent<ICarouselItemViewModel & { isActive: boolean }> {
    render() {
        const { isActive, ...otherProps } = this.props;

        const renderImage = (imageProps: ImageCarouselItemViewModel) => {
            const { picture, orientation } = imageProps;

            return (
                <figure className={styles.Figure}>
                    <Picture {...picture} className={classNames(styles.Img, styles[`Img--${orientation}`])} />
                </figure>
            );
        };

        const renderYouTubeVideo = (videoProps: YouTubeVideoCarouselItemViewModel) => {
            const { youTubeVideoId } = videoProps;

            return <YouTube iframeClassName={styles.Youtube} videoId={youTubeVideoId} />;
        };

        const renderVimeoVideo = (videoProps: VimeoVideoCarouselItemViewModel) => {
            const { videoId } = videoProps;

            return <Vimeo className={styles.Vimeo} videoId={videoId} title="" />;
        };

        return (
            <div className={classNames(styles.CarouselItem, isImage(otherProps) === false && styles.Video)}>
                {isImage(otherProps) && renderImage(otherProps)}
                {isActive && isYoutubeVideo(otherProps) && renderYouTubeVideo(otherProps)}
                {isActive && isVimeoVideo(otherProps) && renderVimeoVideo(otherProps)}
            </div>
        );
    }
}
